"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstagramFeed = exports.TileImgLinkWrapper = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const hooks_1 = require("./lib/hooks");
const ImgWrap = app_1.styled.div `
  height: auto;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
  > img {
    width: 100%;
    height: 100%;
  }
`;
exports.TileImgLinkWrapper = (0, app_1.styled)(app_1.Link) `
  display: block;
  position: relative;
  overflow: hidden;
  aspect-ratio: 1;
  img {
    transition: all 0.3s;
  }
  &:hover {
    img {
      filter: blur(1.5rem);
    }
    h6 {
      opacity: 1;
      top: 50%;
    }
  }

  @media ${app_1.notDesktop} {
    grid-column: span 2;
  }

  @media ${app_1.mobile} {
    grid-column: span 4;
  }
`;
function InstagramFeed({ className, }) {
    const { data } = (0, hooks_1.useInstagram)();
    if (!data) {
        return null;
    }
    const { handle, posts } = data;
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", align: "center", className: className }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "h3" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Instagram" }), (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `https://instagram.com/${handle}`, css: (0, app_1.css) `
            font-size: inherit;
          ` }, { children: (0, jsx_runtime_1.jsxs)("b", { children: ["@", handle] }) }))] })), (0, jsx_runtime_1.jsx)(ui_1.Grid, Object.assign({ templateColumns: "repeat(4, 1fr)", gap: "medium" }, { children: posts.map((post) => {
                    var _a, _b;
                    return ((0, jsx_runtime_1.jsx)(exports.TileImgLinkWrapper, Object.assign({ href: (_a = post.permalink) !== null && _a !== void 0 ? _a : '/' }, { children: (0, jsx_runtime_1.jsx)(ImgWrap, { children: (0, jsx_runtime_1.jsx)("img", { src: post.media_url, alt: (_b = post.caption) !== null && _b !== void 0 ? _b : 'Instagram image' }) }) }), post.id));
                }) }))] })));
}
exports.InstagramFeed = InstagramFeed;
